/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_SeatsInputs */

const en_booking_seats = /** @type {(inputs: Booking_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seats`)
};

const es_booking_seats = /** @type {(inputs: Booking_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asientos`)
};

const fr_booking_seats = /** @type {(inputs: Booking_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Places`)
};

const de_booking_seats = /** @type {(inputs: Booking_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plätze`)
};

const id_booking_seats = /** @type {(inputs: Booking_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kursi`)
};

/** @type {(inputs: Booking_SeatsInputs) => LocalizedString} */
const ja_booking_seats = en_booking_seats;

/** @type {(inputs: Booking_SeatsInputs) => LocalizedString} */
const zh_booking_seats = en_booking_seats;

/** @type {(inputs: Booking_SeatsInputs) => LocalizedString} */
const ar_booking_seats = en_booking_seats;

/** @type {(inputs: Booking_SeatsInputs) => LocalizedString} */
const it_booking_seats = en_booking_seats;

/** @type {(inputs: Booking_SeatsInputs) => LocalizedString} */
const ru_booking_seats = en_booking_seats;

/** @type {(inputs: Booking_SeatsInputs) => LocalizedString} */
const pt_booking_seats = en_booking_seats;

/** @type {(inputs: Booking_SeatsInputs) => LocalizedString} */
const ko_booking_seats = en_booking_seats;

/**
* | output |
* | --- |
* | "Seats" |
*
* @param {Booking_SeatsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const booking_seats = /** @type {((inputs?: Booking_SeatsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_SeatsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booking_seats(inputs)
	if (locale === "es") return es_booking_seats(inputs)
	if (locale === "fr") return fr_booking_seats(inputs)
	if (locale === "de") return de_booking_seats(inputs)
	if (locale === "ja") return ja_booking_seats(inputs)
	if (locale === "zh") return zh_booking_seats(inputs)
	if (locale === "ar") return ar_booking_seats(inputs)
	if (locale === "id") return id_booking_seats(inputs)
	if (locale === "it") return it_booking_seats(inputs)
	if (locale === "ru") return ru_booking_seats(inputs)
	if (locale === "pt") return pt_booking_seats(inputs)
	return ko_booking_seats(inputs)
});